import { render, staticRenderFns } from "./UIDonutChart.vue?vue&type=template&id=0f9031d2"
import script from "./UIDonutChart.vue?vue&type=script&lang=js"
export * from "./UIDonutChart.vue?vue&type=script&lang=js"
import style0 from "./UIDonutChart.vue?vue&type=style&index=0&id=0f9031d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Truncate: require('/skade-pwa/components/ui/atom/Truncate.vue').default})
